import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const TableRow = forwardRef<
  HTMLTableRowElement,
  React.HTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, ref) => (
  <tr
    ref={ref}
    className={twMerge(
      "border-b border-neutral-variant-30 bg-neutral-variant-98 hover:bg-neutral-variant-95/80 dark:bg-neutral-variant-10 dark:hover:bg-neutral-variant-30/40",
      className,
    )}
    {...props}
  />
));
TableRow.displayName = "TableRow";
